import { SweetAlertService } from './../../../../services/sweetalert.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { MweConstants } from 'src/app/constants/mwe-constants.service';
import { CareerService } from 'src/app/services/career.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import Swal from 'sweetalert2';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-job-apply',
  templateUrl: './job-apply.component.html',
  styleUrls: ['./job-apply.component.scss']
})
export class JobApplyComponent implements OnInit, OnDestroy {

  specialities!: any[];
  jobSkills!: any[];

  isFileInputClickedCompanyLogo: boolean = false;
  previewImage: any = null;

  jobPost: any;

  applicantId: any;

  jobPostId: any;
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '10rem',
    minHeight: '0rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],
    toolbarHiddenButtons: [
      [
        'undo',
        'redo',
        'strikeThrough',
        'subscript',
        'superscript',
        'justifyLeft',
        'justifyCenter',
        'justifyRight',
        'justifyFull',
        'indent',
        'outdent',
        'heading',
        'fontName'
      ],
      [
        'fontSize',
        'textColor',
        'backgroundColor',
        'customClasses',
        'link',
        'unlink',
        'insertImage',
        'insertVideo',
        'insertHorizontalRule',
        'removeFormat',
        'toggleEditorMode'
      ]
    ]
  };

  constructor(
    private authService: AuthService,
    private sweetAlertService: SweetAlertService,
    private careerService: CareerService, private readonly snackbarService: SnackbarService,
    private route: ActivatedRoute, private readonly router: Router) { 

      this.jobPostId = this.route.snapshot.paramMap.get('id');
    }

  ngOnInit(): void {
    this.getAllJobPostByFilter();
  }


  getAllJobPostByFilter() {
    this.jobPost = {};
    this.careerService.executePostRequest(MweConstants.getJobPostFilterUrl, { jobPostIds: [this.jobPostId] }).subscribe({
      next: (data) => {
        if (data && data?.data && data.data.length > 0) {
          this.jobPost = data.data[0];
        }
      }, error: (error) => {
        this.snackbarService.openSnackBar(error.error.error, '');
      }
    });
  }

  onSubmitApplication() {
    const body = { jobApplicantKey: { jobPostId: this.jobPost.id, applicantId: this.applicantId } };
    this.careerService.executePostRequest(MweConstants.applyJobPostUrl, body).subscribe({
      next: () => {
        Swal.fire('', 'Job Application submitted successfully !!', 'success');
        this.onCancel();
      },
      error: (error: any) => {
        if (error.status === 400) {
          Swal.fire('Bad Request', 'There was an issue with your application. Please check and try again.', 'error');
        } else if (error.status === 409) {
          Swal.fire('Job has already been applied!', '', 'info');
        } else {
          Swal.fire('Something went wrong', 'Please try again later.', 'error');
        }
      }
    });
  }
  

  onWorkExperience(type :string) {
    if (type === 'work') {
      const workingExperiencesElement = document.getElementById('workingExperiences') as HTMLElement;
      if (workingExperiencesElement) {
        workingExperiencesElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else if (type === 'education') {
      const educationElement = document.getElementById('education') as HTMLElement;
      if (educationElement) {
        educationElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else if (type === 'references') {
      const referencesElement = document.getElementById('references') as HTMLElement;
      if (referencesElement) {
        referencesElement.scrollIntoView({ behavior: 'smooth', block: 'start' });

      } }
  }

  onManagePassword(){
    this.router.navigate(['/manage-password']);
  }

  onLogout() {
    this.sweetAlertService.showConfirmation(
      'Logout',
      'Are you sure you want to logout?',
      'Yes',
      'No'
    ).then((result: any) => {
      if (result.isConfirmed) {
        this.authService.onLogout();
      }
    });
  }

  onCancel() {
    this.router.navigate(['/jobs/view-all-jobs'], { relativeTo: this.route });
  }
  onBack(){
    this.router.navigate(['jobs/job-details',this.jobPostId],{state:{viewAllJobs:true}});
  }

  setApplicantId(applicantId: any) {
    this.applicantId = applicantId;
  }

  ngOnDestroy(): void {
    this.careerService.setJobId(null);
  }
}
